import React from 'react';
import './Testimonials.scss';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Mike Thompson",
      role: "Construction Company Owner",
      image: "👷",
      rating: 5,
      text: "Shadow Tracker has saved us over $50,000 in equipment theft. The stealth design means thieves never find it. Best investment we've made."
    },
    {
      name: "Sarah Chen",
      role: "Fleet Manager",
      image: "👩‍💼",
      rating: 5,
      text: "Managing 25 vehicles is now effortless. Real-time tracking and instant alerts have improved our efficiency by 40%. Highly recommend!"
    },
    {
      name: "James Rodriguez",
      role: "Motorcycle Enthusiast",
      image: "🏍️",
      rating: 5,
      text: "My bike was stolen and recovered within 2 hours thanks to Shadow Tracker. The 24-month battery life is incredible. Worth every penny."
    },
    {
      name: "Emma Wilson",
      role: "RV Owner",
      image: "🚐",
      rating: 5,
      text: "Peace of mind while traveling across the country. The app is intuitive and the tracking is accurate. Customer support is excellent too!"
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <h2>Trusted by Thousands</h2>
        <p className="subtitle">See what our customers are saying about Shadow Tracker</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i}>⭐</span>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.image}</div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
